<template>
    <div class="login_box">
        <div class="title">
            {{ $t('components.register.title') }}
        </div>
        <div v-if="showstep" class="oneform">
            <div class="step">
                <el-divider class="one">
                    <img src="@/assets/no1.png" alt="">
                </el-divider>
                <el-divider class="two">
                    <img src="@/assets/no2_nor.png" alt="">
                </el-divider>
            </div>
            <div class="step-desc">
                <el-divider class="one">
                    <div>{{ $t('components.register.steps.phoneVerification') }}</div>
                </el-divider>
                <el-divider class="two">
                    <div>{{ $t('components.register.steps.setPassword') }}</div>
                </el-divider>
            </div>
            <div class="btn-box">
                <div class="register-type">
                    <el-radio-group v-model="registerType">
                        <el-radio label="phone">{{ $t('components.register.form.phoneRegister') }}</el-radio>
                        <el-radio label="email">{{ $t('components.register.form.emailRegister') }}</el-radio>
                    </el-radio-group>
                </div>
                <el-form @submit.native.prevent :model="numberValidateForm" :rules="numberRules" ref="numberValidateForm" label-width="0px">
                    <div class="btn" v-if="registerType === 'phone'">
                        <el-form-item prop="phone">
                            <el-input
                                :placeholder="$t('components.register.form.phone')"
                                autocomplete="new-password"
                                v-model.number="numberValidateForm.phone">
                                <i slot="prefix">
                                    <img src="@/assets/phone.png" alt="">
                                </i>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="btn" v-if="registerType === 'email'">
                        <el-form-item prop="email">
                            <el-input
                                :placeholder="$t('components.register.form.email')"
                                autocomplete="new-password"
                                v-model="numberValidateForm.email">
                                <i slot="prefix">
                                    <img src="@/assets/email.png" alt="">
                                </i>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="btn vercode-input">
                        <el-form-item prop="vercode">
                            <el-input
                                autocomplete="new-password"
                                :placeholder="$t('components.register.form.verificationCode')"
                                v-model="numberValidateForm.vercode">
                                <i slot="prefix">
                                    <img src="@/assets/vercode.png" alt="">
                                </i>
                            </el-input>
                            <el-button @click="sendMsg" :disabled="isDisabled" type="primary">
                                {{ buttonName }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-form>
                <div>
                    <el-checkbox v-model="checked">
                        {{ $t('components.register.agreement.agree') }}
                    </el-checkbox>
                    <span class="check">{{ $t('components.register.agreement.terms') }}</span>
                </div>
                <div class="loginbtn">
                    <el-button @click="nextStep" type="primary">{{ $t('components.register.form.register') }}</el-button>
                    <div class="login">
                        {{ $t('components.register.login.hasAccount') }}
                        <span @click="loginClick">{{ $t('components.register.login.loginNow') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="twoform">
            <div class="step">
                <el-divider class="one">
                    <img src="@/assets/no1.png" alt="">
                </el-divider>
                <el-divider class="two">
                    <img src="@/assets/no1_hlt.png" alt="">
                </el-divider>
            </div>
            <div class="step-desc">
                <el-divider class="one">
                    <div>{{ $t('components.register.steps.phoneVerification') }}</div>
                </el-divider>
                <el-divider class="two">
                    <div>{{ $t('components.register.steps.setPassword') }}</div>
                </el-divider>
            </div>
            <div>
                <el-form @submit.native.prevent :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
                    <div class="btn">
                        <el-form-item label="">
                            <el-input
                                autocomplete="new-password"
                                :placeholder="$t('components.register.form.nickname')"
                                maxlength="20"
                                v-model="platname">
                                <i slot="prefix">
                                    <img src="@/assets/register_name.png" alt="">
                                </i>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="btn">
                        <el-form-item label="" prop="pass">
                            <el-input
                                type="password"
                                autocomplete="new-password"
                                :placeholder="$t('components.register.form.password')"
                                v-model="ruleForm.pass">
                                <i slot="prefix">
                                    <img src="@/assets/password.png" alt="">
                                </i>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="btn">
                        <el-form-item label="" prop="checkPass">
                            <el-input
                                autocomplete="new-password"
                                type="password"
                                :placeholder="$t('components.register.form.confirmPassword')"
                                v-model="ruleForm.checkPass">
                                <i slot="prefix">
                                    <img src="@/assets/password.png" alt="">
                                </i>
                            </el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="btn">
                    <el-checkbox v-model="checked">
                        {{ $t('components.register.agreement.agree') }}
                    </el-checkbox>
                    <span class="check">{{ $t('components.register.agreement.terms') }}</span>
                </div>
                <div class="loginbtn">
                    <el-button @click="binding" type="primary">{{ $t('components.register.form.register') }}</el-button>
                    <div class="login">
                        {{ $t('components.register.login.hasAccount') }}
                        <span @click="loginClick">{{ $t('components.register.login.loginNow') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getPhoneCode , register , checkOnlyUser , phoneVerification} from '@/api/login/index.js'
import { setToken , setUserInfo } from "@/utils/auth";
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('components.register.form.password')));
            } else {
                if (this.ruleForm.checkPass!== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        }
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('components.register.form.confirmPassword')));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error(this.$t('components.register.rules.passwordMismatch')));
            } else {
                callback();
            }
        }
        // 验证手机号格式
        const validatePhone = (rule, value, callback) => {
            if (!value && !this.numberValidateForm.email) {
                callback(new Error(this.$t('components.register.rules.phoneOrEmailRequired')))
            } else if (value && !/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error(this.$t('components.register.rules.phoneInvalid')))
            } else {
                callback()
            }
        }

        // 验证邮箱格式
        const validateEmail = (rule, value, callback) => {
            const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
            if (!value && !this.numberValidateForm.phone) {
                callback(new Error(this.$t('components.register.rules.phoneOrEmailRequired')))
            } else if (value && !emailRegex.test(value)) {
                callback(new Error(this.$t('components.register.rules.emailInvalid')))
            } else {
                callback()
            }
        }
        return {
            activeName: 'first',
            registerType: 'phone',
            numberValidateForm:{
                phone:'',
                email: '',
                vercode:'',
            },
            ruleForm: {
                pass: '',
                checkPass: '',
            },
            numberRules:{
                phone: [
                    { validator: validatePhone, trigger: 'blur' }
                ],
                email: [
                    { validator: validateEmail, trigger: 'blur' }
                ],
                vercode:[
                    { required: true, message: this.$t('components.register.rules.codeRequired')}
                ]
            },
            rules: {
                pass: [
                    { validator: validatePass, trigger: 'blur' },
                    { required: true,trigger: 'blur'},
                    { pattern: /^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+.])(?!.* ).{8,16}$/ ,
                      message: this.$t('components.register.password.description')}
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' },
                    { required: true,trigger: 'blur'},
                    { pattern: /^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+.])(?!.* ).{8,16}$/ ,
                      message: this.$t('components.register.password.description')}
                ]
            },
            platname: '',
            checked: false,
            showstep: true,
            buttonName: this.$t('components.register.form.getCode'),
            isDisabled: false,
            time: 120
        }
    },
    methods: {
        // 获取手机号验证码
        async getPhoneCode() {
            let params = {
                "mobile": this.numberValidateForm.phone,
                "email": this.numberValidateForm.email,
                "smsmode": "1"
            }
            await getPhoneCode(params).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: "success",
                    duration: 5 * 1000
                });
            })
            .catch(res=>{
              
            })
        },
        // 用户注册
        async registerUser() {
            let params = {
                "password": this.ruleForm.checkPass,
                "phone": this.numberValidateForm.phone,
                "email": this.numberValidateForm.email,
                "smscode": this.numberValidateForm.vercode,
                "username": this.platname,
                "usertype": "2",
            }
            await register(params).then(res=>{
                if(res.data.code == 200) {
                    this.$message({
                        message: this.$t('components.register.messages.registerSuccess'),
                        type: "success",
                        duration: 5 * 1000
                    });
                    let resData = res.data.result
                    setToken(resData.token);
                    setUserInfo(JSON.stringify(resData.userInfo))
                    this.$store.commit("user/SET_USERINFO", resData.userInfo);
                    this.$store.commit('user/SET_TOKEN', resData.token);
                    // 注册成功，绑定联邦方
                    this.$router.push({
                        name: "Bind"
                    })
                    
                } else {
                    this.$message({
                        message: this.$t('components.register.messages.registerFailed'),
                        type: "error",
                        duration: 5 * 1000
                    });
                }
            })
            .catch(res=>{
                // window.location.reload()
            })
        },
        //跳转登录页面
        loginClick() {
            this.$router.push({
                name: "Login"
            })
        },
        binding() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.registerUser()
                } else {
                    return false;
                }
            });
        },
        // 手机号验证
        async phoneVerification() {
            let params = {
                "phone": this.numberValidateForm.phone,
                "email": this.numberValidateForm.email,
                "smscode": this.numberValidateForm.vercode
            }
            await phoneVerification(params).then(res=>{
                if(res.data.success) {
                    this.showstep = false
                } else {
                    this.$message({
                        message: this.$t('components.register.messages.verificationCodeError'),
                        type: "error",
                        duration: 5 * 1000
                    });
                }
            })
            .catch(res=>{
                
            })
        },
        nextStep() {
            this.$refs["numberValidateForm"].validate((valid) => {
                if (valid) {
                    let that = this;
                    if(that.checked) {
                        this.phoneVerification()
                    } else {
                        this.$message({
                            message: this.$t('components.register.messages.agreementRequired'),
                            type: "warning",
                            duration: 5 * 1000
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 发送验证码
        sendMsg() {
            const fieldToValidate = this.registerType === 'phone' ? 'phone' : 'email';
            this.$refs.numberValidateForm.validateField(fieldToValidate, (errorMessage) => {
                if (errorMessage) {
                    return false;
                }

                let params = {
                    phone: this.numberValidateForm.phone,
                    email: this.numberValidateForm.email
                }
                let that = this;
                // 检查用户账户是否唯一
                checkOnlyUser(params).then((res)=>{
                    if (!res.data.success) {
                        return
                    }

                    that.$refs.numberValidateForm.clearValidate('vercode')
                    this.getPhoneCode()
                    that.isDisabled = true;
                    let interval = window.setInterval(function() {
                        that.buttonName = that.$t('components.register.phone.resend', { time: that.time-- });
                        if(that.time < 0) {
                            that.buttonName = that.$t('components.register.form.getCode');
                            that.time = 120;
                            that.isDisabled = false;
                            window.clearInterval(interval);
                        }
                    }, 1000);
                })
                .catch(res=>{
                    
                })     
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.login_box{
    height: 100%;
    background-color: #fff;
    padding: 0 100px;
    width: 400px;
    .title{
        color: #484848;
        font-size: 40px;
        font-weight: 700;
        padding-top: 140px;
        text-align: center;
    }
    .oneform{
        margin-top: 70px;
        .step{
            display: flex;
            .one{     
                background-color: #0B80EA;
                .desc{
                    position: absolute;
                }
                
            }
        }
        .step-desc{
            display: flex;
            .one{
                background-color: #fff;
                margin: 10px 0 40px;
                ::v-deep .el-divider__text.is-center{
                    padding: 0;
                }
            }
            .two{
                background-color: #fff;
                margin: 10px 0 40px;
                ::v-deep .el-divider__text.is-center{
                    padding: 0;
                }
            }
        }
        .btn-box{
            .btn{
                margin-bottom: 30px;
                
                // 确保所有输入框等宽
                ::v-deep .el-input {
                    width: 100%;
                }
                
                // 只针对验证码输入框的特殊样式
                &.vercode-input {
                    display: flex;
                    ::v-deep .el-input {
                        width: 220px;
                        margin-right: 12px;
                    }
                    ::v-deep .el-button {
                        // width: 108px;
                        padding: 12px 10px;
                        background-color: #0B80EA;
                    }
                }
            }
            
            .divider {
                text-align: center;
                position: relative;
                margin: 0;
                height: 0;
                
                span {
                    background: #fff;
                    padding: 0 10px;
                    color: #909399;
                    font-size: 14px;
                    position: relative;
                    z-index: 1;
                    top: -22px;
                }
                
                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 1px;
                    background: #DCDFE6;
                }
            }

            .btn:first-child {
                margin-top: 40px;
            }
        }
        
      
        .forgetpsd{
            div{
                float: right;
                font-size: 14px;
                color: #484848;
        
            }
            cursor: pointer;
            overflow: hidden;
        }
        .loginbtn{
            margin-top: 40px;
            width: 100%;
            ::v-deep .el-button {
                width: 100%;
                height: 50px;
                background-color: #0B80EA;
                font-size: 18px;
            }
            .login{
                margin-top: 20px;
                text-align: center;
                font-size: 16px;
                color: #484848;
                span{
                    color: #0B80EA;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }
        // margin-top: 30px;
        ::v-deep .el-tabs__item{
            color: #9A9A9A;
            font-size: 20px;
            font-weight: 700;
        }
        ::v-deep .el-tabs__item.is-active{
            color: #0B80EA;
            font-size: 20px;
            font-weight: 700;
        }
        ::v-deep .el-tabs__active-bar{
            color: #484848;
            background-color: #0B80EA;
            height: 5px;
        }
        ::v-deep .el-input__prefix, .el-input__suffix{
            display: flex;
            align-items: center;
            padding-left: 15px;
        }
        ::v-deep .el-input--prefix .el-input__inner{
            padding-left: 50px;
        }
        ::v-deep .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled{
            background-color: #F2F3F5 !important;
            border: 1px solid #9A9A9A;
            color: #9A9A9A;
        }
        ::v-deep .el-form-item__content{
            line-height: 0;
        }
        .register-type {
            margin-bottom: 30px;
            text-align: center;
            .el-radio-group {
                display: inline-block;
            }
            .el-radio {
                margin-right: 20px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .twoform{
        margin-top: 70px;
        .step{
            display: flex;
            .one{     
                
                background-color: #0B80EA;
                .desc{
                    position: absolute;
                }
                
            }
            .two{
                background-color: #0B80EA;
            }
        }
        .step-desc{
            display: flex;
            .one{
                background-color: #fff;
                margin: 10px 0 40px;
                ::v-deep .el-divider__text.is-center{
                    padding: 0;
                }
            }
            .two{
                background-color: #fff;
                margin: 10px 0 40px;
                ::v-deep .el-divider__text.is-center{
                    padding: 0;
                }
            }
        }
        .btn:first-child{
            margin-top: 40px;
        }
       
        .btn{
            margin-bottom: 30px;
        }
        .forgetpsd{
            div{
                float: right;
                font-size: 14px;
                color: #484848;
        
            }
            
            cursor: pointer;
            overflow: hidden;
        }
        .loginbtn{
            margin-top: 40px;
            width: 100%;
            ::v-deep .el-button {
                width: 100%;
                height: 50px;
                background-color: #0B80EA;
                font-size: 18px;
            }
            .login{
                margin-top: 20px;
                text-align: center;
                font-size: 16px;
                color: #484848;
                span{
                    color: #0B80EA;
                    font-size: 16px;
                }
            }
        }
        // margin-top: 30px;
        ::v-deep .el-tabs__item{
            color: #9A9A9A;
            font-size: 20px;
            font-weight: 700;
        }
        ::v-deep .el-tabs__item.is-active{
            color: #0B80EA;
            font-size: 20px;
            font-weight: 700;
        }
        ::v-deep .el-tabs__active-bar{
            color: #484848;
            background-color: #0B80EA;
            height: 5px;
        }
        ::v-deep .el-input__prefix, .el-input__suffix{
            display: flex;
            align-items: center;
            padding-left: 15px;
        }
        ::v-deep .el-input--prefix .el-input__inner{
            padding-left: 50px;
        }
    }
    .check{
        font-size: 14px;
        color: #0B80EA;
        cursor: pointer;
    }
}
</style>
